import { Logger } from './logger.package';
import { config } from 'packages/config';

const logger = new Logger(config);

export { logger };
